import { __decorate } from "tslib";
import { customElement, FASTElement } from "@microsoft/fast-element";
import { Router } from "./router";
/**
 * @alpha
 */
let FASTRouter = class FASTRouter extends Router.from(FASTElement) {
};
FASTRouter = __decorate([
    customElement("fast-router")
], FASTRouter);
export { FASTRouter };
